export const attachAuthorAndImagesToListings = (listings) => {
    if (listings?.data?.length) {
        const data = [];
        listings.data.map(l => {
            l.author = listings.included.find(item => item.type == "user" && item.id.uuid == l.relationships.author.data.id.uuid);
            l.images = l.relationships.images.data.map(imageData => {
                return listings.included.find(item => item.type === "image" && item.id.uuid === imageData.id.uuid);
            });
            data.push(l);
        });
        return data;
    };
    return [];
};
